import { Tooltip } from '@mui/material';
import ISigns from '../../models/Indexes/iSigns';
import IPipeMarking from '../../models/Indexes/iPipeMarking';
import ITags from '../../models/Indexes/iTags';
import IAreaMarking from '../../models/Indexes/iAreaMarking';
import ILabels from '../../models/Indexes/iLabels';
import IIndexBase from '../../models/Indexes/iIndexBase';
import IBenchtopSystemsOther from '../../models/Indexes/iBenchtopSystemsOther';
import IRfid from '../../models/Indexes/iRfid';
import IConsumable from '../../models/Indexes/iConsumable';
import IPrinters from '../../models/Indexes/iPrinters';
import IGeneralSafety from '../../models/Indexes/iGeneralSafety';
import ILockoutTagout from '../../models/Indexes/iLockoutTagout';
import Absorbents from '../../models/Indexes/iAbsorbents';

type ProductRow =
  | ISigns
  | IPipeMarking
  | ITags
  | IAreaMarking
  | ILabels
  | IBenchtopSystemsOther
  | IRfid
  | IConsumable
  | IPrinters
  | IGeneralSafety
  | ILockoutTagout
  | Absorbents
  | IIndexBase;

interface ProductAttributeDisplayCellProps<T extends ProductRow> {
  row: T;
  displayValue?: string;
  actualValueKey: keyof T;
}

const ProductAttributeDisplayCell = <T extends ProductRow>({
  row,
  displayValue,
  actualValueKey,
}: ProductAttributeDisplayCellProps<T>) => {
  const actualValue = row[actualValueKey] || '';

  if (actualValue && actualValue !== displayValue) {
    return (
      <Tooltip title={String(actualValue)} arrow>
        <span>{displayValue}</span>
      </Tooltip>
    );
  }

  return <span title={displayValue}>{displayValue}</span>;
};

export default ProductAttributeDisplayCell;
